import React from 'react'
import {ProfileForm} from '../accept-org-invite/profile-form/profile-form'

export const ProfileDefault = () => {
  return <ProfileForm />
}
